const STORAGE_KEY = "skystake-device-id";

let memoryId: string | null = null;

const randomId = (): string => {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}${Math.random().toString(36).slice(2)}`;
};

/**
 * A random id for this browser, sent as `x-device-id` so the referral check can
 * compare devices. Kept in localStorage; a blocked storage falls back to one id per page load.
 */
export const getDeviceId = (): string => {
  if (memoryId) return memoryId;
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored) return (memoryId = stored);
    const created = randomId();
    window.localStorage.setItem(STORAGE_KEY, created);
    return (memoryId = created);
  } catch {
    return (memoryId = randomId());
  }
};
